import React from 'react';

import { PetPill } from './PetPill';

const CustomMultiValue = ({ data, removeProps }) => {
  const { pet } = data;

  const handleRemove = (event) => {
    if (removeProps?.onClick) {
      removeProps.onClick(event);
    }
  };

  return (
    <PetPill
      onRemove={handleRemove}
      pet={pet}
    />
  );
};

export { CustomMultiValue };
